import React, { useMemo, useRef } from 'react';
import { identity, pick, compose } from 'ramda';
import Overlay from 'js/components/common/Overlay';
import { useCustomSelector } from 'js/store/hooks';
import { POPUPS_REDUCER } from 'js/store/constants';

import { ManagedPopupFactory } from '../ManagedPopupFactory';
import { withDynamicReducer, useDynamicReducerSelector } from './store';

import style from '../PopupManager.scss';

export const LayerBare = ({
    layerId,
    isLayerVisible,
    onPrev,
    onNext
}) => {
    const { popups, layers, layersMeta } = useCustomSelector(POPUPS_REDUCER, pick(['popups', 'layers', 'layersMeta']));
    const layerRef = useRef();
    const layoutRef = useRef();
    const refs = useMemo(() => ({ layerRef, layoutRef }), []);

    const { onOverlayClick } = useDynamicReducerSelector(pick(['onOverlayClick']));

    const layer = layers[layerId];
    const layerMeta = layersMeta[layerId];

    if (!layer || !isLayerVisible) {
        return null;
    }

    const { activePopupIndex, disableNavigation, enableOverlay = true } = layerMeta;
    const activePopupId = layer[activePopupIndex];
    const { isModal, layerClassNames = {} } = popups[activePopupId];
    const classNames = pick(['layer', 'overlay', 'layout'], layerClassNames);
    const { length } = layer;

    const controlsProps = length > 1 && !disableNavigation ? {
        label: `${activePopupIndex + 1}/${length}`,
        onPrev: activePopupIndex !== 0 ? onPrev : null,
        onNext: activePopupIndex !== length - 1 ? onNext : null

    } : null;

    return (
        <div
            id={`LAYER_${layerId}`}
            className={`${style.layer} ${classNames.layer || ''}`}
            ref={layerRef}
        >
            {enableOverlay && (
                <Overlay
                    className={classNames.overlay}
                    onClick={isModal ? identity : onOverlayClick}
                />
            )}
            <div className={`${style.layout} ${classNames.layout || ''}`} ref={layoutRef}>
                {layer
                    .map(id => popups[id])
                    .map(popup => <ManagedPopupFactory
                        {...popup}
                        refs={refs}
                        key={popup.id}
                        controls={controlsProps}
                        isActive={popup.id === activePopupId}
                    />)
                }
            </div>
        </div>
    );
};

export const Layer = compose(
    withDynamicReducer()
)(LayerBare);
